import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"

export default class extends Controller {
  connect() {
    const ctx = this.element;
    const xValues = JSON.parse(ctx.dataset.x).map((x) => new Date(x));
    const yValues = JSON.parse(ctx.dataset.y);
    const chartTitle = ctx.dataset.title;

    const style = getComputedStyle(document.documentElement);
    const accent        = style.getPropertyValue('--bs-primary').trim();
    const gridColor     = style.getPropertyValue('--bs-border-color').trim();
    const tickColor     = style.getPropertyValue('--bs-secondary-color').trim();
    const titleColor    = style.getPropertyValue('--bs-body-color').trim();

    new Chart(ctx, {
      type: "line",
      data: {
        labels: xValues,
        datasets: [{
          fill: false,
          lineTension: 0,
          backgroundColor: accent,
          borderColor: accent,
          pointBackgroundColor: accent,
          data: yValues
        }]
      },
      options: {
        scales: {
          x: {
            grid: { color: gridColor },
            ticks: { color: tickColor },
            type: "time",
            time: {
              unit: "day",
              displayFormats: { "day": "dd/MM" }
            }
          },
          y: {
            min: Math.floor(Math.min(...yValues) / 5) * 5,
            max: Math.ceil(Math.max(...yValues) / 5) * 5,
            grid: { color: gridColor },
            ticks: { color: tickColor }
          }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: chartTitle,
            color: titleColor,
            font: { size: 16 }
          }
        }
      }
    });
  }
}
